import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import App from './App'
import Vue from 'vue'
import uView from "uview-ui";
import './uni.promisify.adaptor'
import store from './store/index.js'

Vue.config.productionTip = false
App.mpType = 'app'

Vue.prototype.$baseUrl = 'http://localhost:10031/';
// Vue.prototype.$baseUrl = 'https://dmtest.ahapp.net/yyb_web_api/';
// Vue.prototype.$baseUrl = 'https://www.yyb.red/yyb_web_api/'
Vue.prototype.$store = store;

Vue.use(uView);

const app = new Vue({
	store,
	...App
})

// http接口API抽离
import httpApi from '@/utils/http.api.js'
Vue.use(httpApi, app)

// 请求拦截器
import interceptor from '@/utils/http.interceptor.js'
Vue.use(interceptor, app)

app.$mount()